export default __webpack_public_path__ + "static/logo-bg-1b21d71bde991b8d2b97ab6230455b63.png";